export default {
  isModified: false,
  editTMP: null,
  enterpriseColor: '#1B2631',
  enterpriseID: null,
  enterpriseName: '',
  userName: '',
  BGColor: '#56A099',
  BGColorSecundary: '#CCCCCC',
  BGColorContent: '#FFFFFF',
  Color: '#FFFFFF',
  ColorSecundary: '#495057',
  ColorContent: '#495057',
  GlobalFont: 'Roboto',
  Font: 'Roboto',
  FontSecundary: 'Roboto',
  FontContent: 'Roboto',
  FontSize: 20,
  FontSizeSecundary: 16,
  FontSizeContent: 14,
  Carousel: [],
  Logo: 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png',
  Languages: ['es'],
  locale: 'es',
  withGradient: true,
  withLine: false,
  menus: [],
  contents: [],
  collapseContent: false,
  mainFormWidth: null,
  expandMenuID: null
}
